export default "__VITE_ASSET__DW_N28bo__"